<script>
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import sl from "@/Prevodi/UrejanjePodatkov-sl.json";
import en from "@/Prevodi/UrejanjePodatkov-en.json";
import it from "@/Prevodi/UrejanjePodatkov-it.json";
export default {
  components: {
    Notification,
  },
  props: {
    UserID: String,
    FullUser: Object,
  },
  data() {
    return {
      showSettings: false,
      podatki: null,
      email: null,
      naslov: null,
      posta: null,
      kraj: null,
      telefon: null,
      licenca: null,
      /* OBVESTILA */
      ShowNoti: false,
      text: '',
      types: '',
    }
  },
  created() {
    // await this.loadTranslations('sl', './src/prevodi/UrejanjePodatkov-sl.json');
    // await this.loadTranslations('en', './src/prevodi/UrejanjePodatkov-en.json');
    // await this.loadTranslations('it', './src/prevodi/UrejanjePodatkov-it.json');
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.BeriPodatke();
  },
  methods: {
    OpenSettings() {
      this.showSettings = !this.showSettings;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    BeriPodatke() {
      axios.get('./api/sifranti/piloti/izpis?osebni=1', {withCredentials: true}).then((response) => {
        this.podatki = response.data.piloti[0];
        this.email = response.data.piloti[0].email;
        this.naslov = response.data.piloti[0].naslov;
        this.posta = response.data.piloti[0].posta;
        this.kraj = response.data.piloti[0].kraj;
        this.telefon = response.data.piloti[0].telefon;
        this.licenca = response.data.piloti[0].licenca;
      }).catch((napaka) => {
        this.text = `Napaka pri branju podatkov.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Validate() {
      if (this.email !== '' && this.naslov !== '' && this.posta !== '' && this.kraj !== '' && this.telefon !== '') {
        if (this.email !== this.podatki.email) {
          var ePodatki = new URLSearchParams();
          ePodatki.append('nEmail', this.email);
          ePodatki.append('pID', this.podatki.id);
          axios.post('./api/sifranti/piloti/uredi/email/', ePodatki, {withCredentials: true}).then((response) => {
            this.types = "Uspešno";
            this.text = "Povezava za posodobitev e-naslova vam je bila poslana";
            this.ShowNoti = true;
          }).catch((napaka) => {
            this.types = "Napaka";
            this.text = napaka;
            this.ShowNoti = true;
          })
        }
        var podatki = new URLSearchParams();
        podatki.append('ime', this.podatki.ime);
        podatki.append('idU', this.podatki.id);
        podatki.append('priimek', this.podatki.priimek);
        podatki.append('naslov', this.naslov);
        podatki.append('posta', this.posta);
        podatki.append('kraj', this.kraj);
        podatki.append('telefon', this.telefon);
        podatki.append('klub', this.podatki.klub);
        podatki.append('nalet_jadralno', this.podatki.nalet_jadralno);
        podatki.append('nalet_motorno', this.podatki.nalet_motorno);
        podatki.append('email', this.podatki.email);
        podatki.append('opomba', this.podatki.opomba);
        podatki.append('instruktor', this.podatki.instruktor);
        podatki.append('instruktor_jadralno', this.podatki.instruktor_jadralno);
        podatki.append('instruktor_ultralight', this.podatki.instruktor_ultralight);
        podatki.append('vlecni_rating', this.podatki.vlecni_rating);
        podatki.append('licenca', this.licenca);
        podatki.append('jadralni_pilot', this.podatki.jadralni_pilot);
        podatki.append('motorni_pilot', this.podatki.motorni_pilot);
        podatki.append('ultralight_pilot', this.podatki.ultralight_pilot);
        axios.post('./api/sifranti/piloti/uredi/', podatki, {withCredentials: true}).then((response) => {
          this.types = "Uspešno";
          this.text = "Podatki uspešno posodobljeni!";
          this.ShowNoti = true;
        }).catch((napaka) => {
          this.types = "Napaka";
          this.text = napaka;
          this.ShowNoti = true;
        });
      } else {
        this.types = "Napaka";
        this.text = "Preverite, če imate izpolnjena vsa polja!";
        this.ShowNoti = true;
      }
    },
  }
}
</script>
<template>
  <!--       <div class="drop-down-icon text-black" @click.prevent="OpenSettings()">
          <i v-show="!showSettings" class="fas fa-chevron-right"></i>
          <i v-show="showSettings" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" type="text" id="Skupno" @click.prevent="OpenSettings()">{{$t('labelsPodatki.buttons.odpri')}}</button> -->
  <transition name="fade">
    <div class='modern-section-body mt-2'>
      <!-- E-NASLOV -->
      <div class="modern-form-group">
        <label class="modern-form-label" for="password">{{$t('labelsPodatki.email')}}</label>
        <div class="modern-input-group">
          <input class="modern-form-input" autocomplete="off" type="text" id="password" v-model="email" required />
        </div>
        <span class='text-danger'>S spremembo email naslova boste spremenili tudi e-mail naslov za prijavo v aplikacijo.<br/>Pred uveljavljanjem spremembe boste morali nov email naslov potrditi</span>
      </div>
      <!-- NASLOV -->
      <div class="modern-form-group">
        <label class="modern-form-label" for="password">{{$t('labelsPodatki.naslov')}}</label>
        <div class="modern-input-group">
          <input class="modern-form-input" autocomplete="off" type="text" id="password" v-model="naslov" required />
        </div>
      </div>
      <!-- POSTA -->
      <div class="modern-form-group">
        <label class="modern-form-label" for="password">{{$t('labelsPodatki.posta')}}</label>
        <div class="modern-input-group">
          <input class="modern-form-input" autocomplete="off" type="text" id="password" v-model="posta" required />
        </div>
      </div>
      <!-- KRAJ -->
      <div class="modern-form-group">
        <label class="modern-form-label" for="password">{{$t('labelsPodatki.kraj')}}</label>
        <div class="modern-input-group">
          <input class="modern-form-input" autocomplete="off" type="text" id="password" v-model="kraj" required />
        </div>
      </div>
      <!-- TELEFON -->
      <div class="modern-form-group">
        <label class="modern-form-label" for="password">{{$t('labelsPodatki.telefon')}}</label>
        <div class="modern-input-group">
          <input class="modern-form-input" autocomplete="off" type="text" id="password" v-model="telefon" required />
        </div>
      </div>
      <!-- LICENCA -->
      <!-- 	      	<div class="modern-form-group">
                    <label class="modern-form-label" for="password">{{$t('labelsPodatki.licenca')}}</label>
                    <div class="modern-input-group">
                        <input class="modern-form-input" autocomplete="off" type="text" id="password" v-model="licenca" required />
                    </div>
                </div> -->
      <div class="modern-form-actions">
        <button class="modern-btn modern-btn-primary" @click.prevent="Validate()">
          <i class="fas fa-sync-alt"></i>
          {{$t('labelsPodatki.buttons.posodobi')}}
        </button>
      </div>
    </div>
  </transition>
  <Transition name="fade">
    <Notification class="top-0" v-if="ShowNoti" :message="this.text" :type="this.types"  @da="Disable()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
</template>